export default __webpack_public_path__ + "static/media/googlepay.f11f6f9c.svg";